import React from "react";
import { Navigate, useParams } from "react-router-dom";

/**
 * Redirects /Surveys/:surveyId/results to Survey Details with the Results tab active.
 * Detailed results are now shown under Survey Details → Results tab.
 */
function SurveyResults() {
  const { surveyId } = useParams();
  return <Navigate to={`/Surveys/${surveyId}/details?tab=results`} replace />;
}

export default SurveyResults;
